export default "__VITE_ASSET__9fc884de__"